import { useForm } from "react-hook-form";
import { FormDiv } from "../../../components/atoms/FormDiv";
import { FormHook } from "../../../components/molecules/FormHook";
import { FormInput } from "../../../components/molecules/FormInput";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SubmitButton } from "../../../components/atoms/SubmitButton";
import { TITULO_IDIOMA_REG } from "../../../utils/constantes";
import { getAllIdiomas } from "../../../services/idioma.service";
import { FormSelect } from "../../../components/atoms/FormSelect";
import {crearModulo,getAllModulosByIdIdioma,} from "../../../services/modulo.service";
import { getAllNiveles } from "../../../services/nivel.service";
import { showAlert, showErrorAlert } from "../../../components/molecules/ShowAlert";

export const RegistrarModuloPage = () => {
  const navigate = useNavigate();
  const DIR_ICON_MAT = "img/iconos/titulo de docente (con la pizarra).svg";
  const [estaCargando, setEstaCargando] = useState(false);
  const [idiomas, setIdiomas] = useState([]);
  const [idioma, setIdioma] = useState(null);
  const [modulos, setModulos] = useState(null);
  const [niveles, setNiveles] = useState(null);

  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    obtenerIdiomas();
    obtenerNiveles();
  }, []);

  useEffect(() => {
    if (idioma) {
      console.log("entre uwu");
      getAllModulosByIdioma(idioma);
    } else {
      console.log("no entre");
    }
  }, [idioma]);

  const obtenerIdiomas = async () => {
    await getAllIdiomas()
      .then((idiomas) => {
        console.log(idiomas);
        setIdiomas(
          idiomas?.map((idioma) => ({
            value: idioma?.idIdioma,
            label: idioma?.nombre,
          }))
        );
      })
      .catch((err) => console.log(err));
  };

  const obtenerNiveles = async () => {
    await getAllNiveles()
      .then((niveles) =>
        setNiveles(
          niveles?.map((nivel) => ({
            value: nivel?.idNivel,
            label: nivel?.nombre,
          }))
        )
      )
      .catch((err) => console.log(err));
  };

  const handleSeleccionarIdiomaChange = async (data) => {
    setIdioma(data);
    getAllModulosByIdioma(data);
  };

  const getAllModulosByIdioma = async (idioma) => {
    await getAllModulosByIdIdioma(idioma?.value)
      .then((modulos) => setModulos(modulos))
      .catch((err) => console.log(err));
  };

  const submit = async (data) => {
    data.idIdioma = data.idIdioma.value;
    data.idNivel = data.idNivel.value;
    console.log("data: ", data);
    setEstaCargando(true);
    try {
      await crearModulo(data);
      showAlert({});
    } catch (err) {
      const errorMessage = err.response.data.message;
      showErrorAlert({ text: errorMessage })
    } finally {
      setEstaCargando(false);
    }
  };

  return (
    <ContenedorPageTemplate dirIcono={DIR_ICON_MAT} titulo={TITULO_IDIOMA_REG}>
      <FormHook
        handleSubmit={handleSubmit}
        submit={submit}
        className="w-[min(100%,700px)] mx-auto"
      >
        <FormDiv>
          <FormSelect
            name="idIdioma"
            label="Idiomas"
            control={control}
            options={idiomas}
            validation={{ required: "Campo requerido" }}
            placeholder="Idiomas"
            handleChange={handleSeleccionarIdiomaChange}
            error={errors.idIdioma}
            className="md:w-1/2 md:pr-2"
          />
          <div className="min-h-[100px] border p-2 flex justify-center">
            {modulos && modulos?.length > 0 ? (
              <div className="overflow-x-auto w-full">
                <table className="w-full table-auto">
                  <tbody className="flex gap-2">
                    {modulos?.map((modulo) => (
                      <tr
                        key={modulo?.idModulo}
                        className="border p-2 flex-shrink-0 flex flex-col w-[200px] bg-blue-300"
                      >
                        <td className="font-bold text-center">
                          {modulo?.nombre}
                        </td>
                        <td>
                          <strong>Sigla:</strong> {modulo?.sigla}
                        </td>
                        <td>
                          <strong>Nivel:</strong> {modulo?.nivel?.nombre}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : modulos && modulos?.length === 0 ? (
              <span>
                No hay módulos que mostrar para el idioma: {idioma?.label}
              </span>
            ) : (
              <span>Selecciona un idioma para ver sus módulos</span>
            )}
          </div>
        </FormDiv>
        <FormDiv>
          <FormSelect
            name="idNivel"
            label="Nivel"
            control={control}
            options={niveles}
            validation={{ required: "Campo requerido" }}
            placeholder="Seleccionar nivel"
            error={errors.idNivel}
            className="md:w-1/2 md:pr-2"
          />
          <FormInput
            id="nombre"
            label="Nombre de modulo"
            type="text"
            placeholder="Nombre"
            register={register}
            validation={{
              required: { value: true, message: "Campo requerido" },
            }}
            error={errors.nombre}
          />
          <FormInput
            id="sigla"
            label="Sigla de modulo"
            type="text"
            placeholder="M1-IDIOMA-NIVEL"
            register={register}
            validation={{
              required: { value: true, message: "Campo requerido" },
            }}
            error={errors.sigla}
          />
        </FormDiv>
        <SubmitButton estaCargando={estaCargando} text="Guardar" />
      </FormHook>
    </ContenedorPageTemplate>
  );
};
